export default function ViewWebinarDialogController(
  $sce,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.trustedMediaUrl = $sce.trustAsResourceUrl(vm.mediaUrl);

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.support.viewWebinarDialog);
  }
}

ViewWebinarDialogController.$inject = [
  '$sce',
  'ssDialogService'
];
